// extracted by mini-css-extract-plugin
export default {"tableWrapper":"DataTable_tableWrapper__g4D4V","table":"DataTable_table__VimPf","emptyMsg":"DataTable_emptyMsg__h315j"};